import PropTypes from "prop-types";

export const filterGroupInterface = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string,
  type: PropTypes.string,
  values: PropTypes.array,
  visualType: PropTypes.string,
}

export const filterValueInterface = {
  id: PropTypes.number.isRequired,
  additionalImages: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  displayText: PropTypes.string,
  filterGroup_id: PropTypes.number,
  icon: PropTypes.string,
  lockedInWizard: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}

export const navigationFilterValueInterface = {
  filterId: PropTypes.number.isRequired,
  filterGroupId: PropTypes.number.isRequired,
}
